import {
  Login,
  Signup,
  Otp,
  ForgotPassword,
  ForgotPasswordReset,
} from "./Auth";
import { Dashboard } from "./Dashboard";
import { Customer } from "./Customer";
import { TransactionsNew } from "./Transactions";
import { Orders } from "./Orders";
import { Booking } from "./Booking";
import {
  Wallet,
  FundWallet,
  TransferFundOptions,
  NewBeneficiary,
  SavedBeneficiary,
  TransferFunds,
  TransferPinConfirm,
  Withdraw,
  TransferSuccess,
  TransferFailed,
  WalletExchange,
  AccountStatement,
  BankAccountReq,
} from "./Wallet";

import {
  AccountManager,
  BusinessInfo,
  Security,
  Settings,
  InviteFriends,
  Logout,
  ContactSupport,
  WithdrawalAccount,
  ManagePayroll,
  ManageProductSalesConfig,
  InventoryConfig,
  Kyc,
  AddBusiness,
  Faqs,
  GeneralSettings,
  CardInfo,
  InvoiceReminder,
  Subscriptions,
  RenewSub,
  ApiKeys,
  FreePlanConfirmation,
} from "./Settings";
import {
  PaymentLink,
  DeletePaymentLink,
  PaymentLinkCheckout,
} from "./PaymentLink";

import {
  Invoice,
  EditInvoice,
  InvoiceSummary,
  NewBulkInvoice,
  NewInvoice,
  UpdateInvoice,
  ViewCustomer,
} from "./Invoice";
import { Measurement } from "./Measurement";

import {
  AppHome,
  BusinessReportDL,
  NumberVerification,
  BusinessChartCard,
  BusinessInsightCard,
  QuickLinksCard,
  ReminderCard,
  ThisWeekCard,
} from "./AppHome";

import { CreateWebsite, Styles, StyleRequest } from "./Website";
import { WebsiteConfig } from "./WebsiteConfig";
import SubscriptionExpired from "./SubscriptionExpired/SubscriptionExpired";
import { NewsLetter } from "./NewsLetter";
import { ContactUs } from "./ContactUs";
import { ThemeConfig } from "./ThemeConfig";
import { WithdrawalAccounts } from "./WithdrawalAccounts";

export {
  Login,
  Signup,
  Otp,
  ForgotPassword,
  ForgotPasswordReset,
  Dashboard,
  Customer,
  TransactionsNew,
  Orders,
  Booking,
  Wallet,
  FundWallet,
  TransferFundOptions,
  NewBeneficiary,
  SavedBeneficiary,
  TransferFunds,
  TransferPinConfirm,
  Withdraw,
  TransferSuccess,
  TransferFailed,
  WalletExchange,
  AccountStatement,
  BankAccountReq,
  AccountManager,
  BusinessInfo,
  Security,
  Settings,
  InviteFriends,
  Logout,
  ContactSupport,
  WithdrawalAccount,
  ManagePayroll,
  ManageProductSalesConfig,
  InventoryConfig,
  Kyc,
  AddBusiness,
  Faqs,
  GeneralSettings,
  CardInfo,
  InvoiceReminder,
  Subscriptions,
  RenewSub,
  ApiKeys,
  FreePlanConfirmation,
  Invoice,
  EditInvoice,
  InvoiceSummary,
  NewBulkInvoice,
  NewInvoice,
  UpdateInvoice,
  ViewCustomer,
  PaymentLink,
  DeletePaymentLink,
  PaymentLinkCheckout,
  AppHome,
  BusinessReportDL,
  NumberVerification,
  BusinessChartCard,
  BusinessInsightCard,
  QuickLinksCard,
  ReminderCard,
  ThisWeekCard,
  Measurement,
  CreateWebsite,
  Styles,
  StyleRequest,
  WebsiteConfig,
  SubscriptionExpired,
  NewsLetter,
  ContactUs,
  ThemeConfig,
  WithdrawalAccounts,
};
